import React, { useMemo, useState, type ReactNode } from 'react'
import { BulkAddUsersContext } from '@/contexts/BulkAddUsersContext'
import type { BulkAddUsersJob } from '@/types/user'

interface Props {
  children: ReactNode
}

export const BulkAddUsersProvider: React.FC<Props> = ({ children }) => {
  const [job, setJob] = useState<BulkAddUsersJob | null>(null)
  const [organizationId, setOrganizationId] = useState<string>('')

  const contextValue = useMemo(
    () => ({
      job,
      setJob,
      organizationId,
      setOrganizationId,
    }),
    [job, setJob, organizationId, setOrganizationId]
  )

  return <BulkAddUsersContext.Provider value={contextValue}>{children}</BulkAddUsersContext.Provider>
}
